import createTheme from "./createTheme.es.js";
const defaultTheme = createTheme();
const defaultTheme$1 = defaultTheme;
export {
  defaultTheme$1 as default
};
//# sourceMappingURL=defaultTheme.es.js.map
